import React, { useEffect } from 'react'

// next components
import { useRouter } from 'next/router'

// third party components
import { useDispatch } from 'react-redux'

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// components

// custom functions
import { useViewport } from 'utils'

// resources
import SeeMoreButton from 'components/Button/SeeMoreButton'
import OutlineButton from 'components/Button/OutlineButton'
import HomeEditionCard from 'components/Card/HomeEditionCard'
import SkeletonCard from 'components/SkeletonCard'

// styles
import styles from './index.module.scss'

// call apis

const LimitedEditionSection = props => {
  const { category, isEditionLoaded, editionList } = props
  const router = useRouter()
  const dispatch = useDispatch()

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

  useEffect(() => {
    if (editionList && editionList.length > 0) {
      ;(async () => {
        for (let index = 0; index < editionList.length; index++) {
          let data = editionList[index]
          if (data.token_id !== undefined) fetch(`/nft/${data.tokenId}`).then(e => e.text())
          if (index % 4 == 3) {
            await sleep(1000)
          }
        }
      })()
    }
  }, [editionList])

  return editionList?.length > 0 ? (
    <section className={styles.container}>
      <div className="relative w-full flex justify-between items-center z-10">
        <div className={styles.title}>Live&nbsp;Editions</div>
        <div className="z-10 mr-[16px] sm:mr-[60px] md:mr-[70px]">
          <SeeMoreButton
            label="View All"
            onClick={() => {
              dispatch({ type: 'set', exploreTab: 0 })
              dispatch({ type: 'set', availabilityFilter: 2 })
              dispatch({ type: 'set', artworkCategory: category })
              router.push('/explore')
            }}
          />
        </div>
      </div>
      {/* <div className="w-full mt-[25px] lg:mt-[30px] z-10 px-[10]">
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? true : false}
          slidesPerView={
            viewport === 'xs'
              ? 1.41
              : viewport === 'sm' || viewport === 'md'
              ? 2
              : viewport === '2xl'
              ? 5
              : viewport === 'xl'
              ? 4
              : 4
          }
          spaceBetween={
            viewport === 'xs' ? 20 : viewport === 'sm' || viewport === 'md' ? 30 : viewport === 'lg' ? 26 : 26
          }
          centeredSlides={viewport === 'xs'}
          loop={true}
          modules={[Navigation]}
          className={
            editionList.length > 4
              ? 'auctionNavigationSwiper'
              : (viewport === 'lg' || viewport === 'xl') && editionList.length > 3
              ? 'auctionNavigationSwiper'
              : 'noScrollNavigationSwiper'
          }
        >
          {editionList.map((item, index) => (
            <SwiperSlide key={index}>
              <HomeEditionCard data={item} onClick={() => {}} key={index} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div> */}

      <div className="hidden lg:grid w-full xs:grid-cols-20 gap-[18px] md:gap-[22px] lg:gap-[22px] mt-[17px] lg:mt-[30px] z-10 sm:px-[7px] lg:px-[0px]">
        {editionList.map((item, index) => (
          <div className="xs:col-span-10 lg:col-span-5 2xl:col-span-4" key={item.id}>
            <HomeEditionCard
              data={item}
              type={item.maxSupply === null ? 'open' : 'limit'}
              onClick={() => {}}
              key={index}
            />
          </div>
        ))}
      </div>

      <div
        className={`w-full lg:hidden flex gap-[15px] overflow-x-auto mt-[15px] px-[16px] sm:px-[60px] md:px-[70px] ${styles.hideScrollbar}`}
      >
        {editionList.map((item, index) => (
          <div key={index} className="max-w-[293px] min-w-[293px] h-[410px] overflow-hidden">
            <HomeEditionCard
              data={item}
              type={item.maxSupply === null ? 'open' : 'limit'}
              onClick={() => {}}
              key={index}
            />
          </div>
        ))}
      </div>

      {/* <div className="w-full flex sm:hidden justify-center lg:mt-0 mt-[20px]">
        <div className="w-full max-w-[300px] z-10">
          <OutlineButton
            label="See More"
            fullWidth
            onClick={() => {
              dispatch({ type: 'set', exploreTab: 0 })
              dispatch({ type: 'set', availabilityFilter: 2 })
              dispatch({ type: 'set', artworkCategory: category })
              router.push('/explore')
            }}
            fontSize="16px"
            height="41px"
            borderRadius="8px"
          />
        </div>
      </div> */}
    </section>
  ) : !isEditionLoaded ? (
    <div>
      <div className="w-full h-[539px] lg:h-[610px]">
        <div className="ml-[16px] sm:ml-[0px] sm:pl-[0px] w-[163px] h-[36px] mt-[30px]  sm:mt-[60px] rounded-[18px] overflow-hidden">
          <div className="skeletonLoader" />
        </div>
        <div className="min-w-full h-[420px] lg:flex hidden justify-center gap-[29px] mt-[26px]">
          <SkeletonCard width={300} borderRadius={10} />
          <SkeletonCard width={300} borderRadius={10} />
          <SkeletonCard width={300} borderRadius={10} />
          <SkeletonCard width={300} borderRadius={10} />
          <SkeletonCard width={300} borderRadius={10} />
        </div>
        <div className="w-full lg:hidden flex gap-[15px] mt-[20px] ml-[16px]">
          <SkeletonCard width={260} minWidth={260} borderRadius={10} />
        </div>

        <div className="w-full lg:hidden flex justify-center mt-[30px]">
          <div className="w-[260px] h-[45px] rounded-[20px] overflow-hidden">
            <div className="skeletonLoader" />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default LimitedEditionSection
